(function () {
    'use strict';

    angular.module('swif.openbase').config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/configuration/products/table_view', {
            templateUrl: 'partials/openbase/products_table_view.html',
            controller: 'SwifOpenbaseProductsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }])

    .factory('swifOpenbaseProductService',[
        'swifFrameworkService',
        function (swif) {
            var service = {};
            service.createCollection = function () {
                var filter = {};
                swif.data.sortOn(filter, 'name', 'ASC');
                return swif.collections.createOrUpdate('products', 'product', filter, {location: true})
                .then(function (collection) {
                    return collection;
                });
            };
            service.getCollection = function () {
                return swif.collections.getCollection('products');
            };
            service.preValidate = function (data) {
                var ret = true;
                var collection = service.getCollection();
                if (collection) {
                    ret = collection.preValidate(data);
                }
                return ret;
            };
            service.callback = function (error, data) {
                var collection = service.getCollection();
                collection.defaultActionCallback(error, data);
            };
            return service;
        }
    ])

    .controller('SwifOpenbaseProductsController', [
        '$scope', 'swifFrameworkService', 'swifOpenbaseProductService',
        function ($scope, swif, service) {

            service.createCollection().then(function (collection) {
                $scope.products = collection;
            });
            $scope.modules = swif.module.modules;
            $scope.preValidate = service.preValidate;
            $scope.callback = service.callback;
        }
    ]);
/**
    "ean13": false,
    "code": false,
    "incoming_qty": 0.0,
    "standard_price": 1.0,
    "actions": ["update", "delete"],
    "name_template": "Alsh Du Cadiou",
    "property_account_income": false,
    "seller_qty": 0.0,
    "company_id": [1, "Siclicville"],
    "internal_bookable_notice": 0.0,
    "loc_rack": false,
    "pricelist_id": [],
    "price_margin": 1.0,
    "property_stock_account_input": false,
    "warehouse_id": [],
    "outgoing_qty": 0.0,
    "openstc_maintenance": false,
    "variants": false,
    "partner_ref": "Alsh Du Cadiou",
    "rental": false,
    "packaging": [],
    "seller_id": false,
    "name": "Alsh Du Cadiou",
    "seller_ids": [],
    "empruntable": false,
    "isroom": false,
    "supply_method": "buy",
    "orderpoint_ids": [],
    "weight": 0.0,
    "attachment_count": 0,
    "checkout_lines": [],
    "ask_lines": [],
    "description_purchase": false,
    "etat": false,
    "virtual_available": 0.0,
    "need_infos_supp": false,
    "product_tmpl_id": [54, "Alsh Du Cadiou"],
    "state": "expired",
    "price": 0.0,
    "active": true,
    "loc_row": false,
    "seller_delay": 1,
    "loc_case": false,
    "property_stock_account_output": false,
    "lst_price": 1.0,
    "warranty": 0.0,
    "property_stock_procurement": [6, "Emplacements Virtuels / Approvisionnements"],
    "uos_id": false,
    "list_price": 1.0,
    "color": "#eca311",
    "mes_type": "fixed",
    "qty_available": 0.0,
    "uos_coeff": 1.0,
    "sale_ok": true,
    "asks": "[]",
    "asked_qty": 0.0,
    "purchase_ok": true,
    "product_manager": false,
    "block_booking": true,
    "type_prod": false,
    "description_sale": false,
    "track_incoming": false,
    "property_stock_production": [7, "Emplacements Virtuels / Production"],
    "supplier_taxes_id": [],
    "volume": 0.0,
    "seller_info_id": false,
    "procure_method": "make_to_stock",
    "property_stock_inventory": [5, "Emplacements Virtuels / Pertes d'inventaire"],
    "cost_method": "standard",
    "valuation": "manual_periodic",
    "sale_delay": 7.0,
    "type": "service",
    "product_image": false,
    "isservice": false,
    "track_production": false,
    "qty_available_by_location": "[{\"warehouse\": \"Your Company\", \"qty\": 0.0, \"location_id\": 12, \"location\": \"Stock\", \"warehouse_id\": 1}]",
    "bloquant": false,
    "price_extra": 0.0,
    "uom_id": [1, "PCE"],
    "default_code": false,
    "iscategid": false,
    "max_bookable_qty": 0,
    "location_id": [],
    "id": 54,
    "track_outgoing": false,
    "stock_threshold": 0.0,
    "uom_po_id": [1, "PCE"],
    "openstc_reservable": false,
    "description": false,
    "weight_net": 0.0,
    "openresa_property_manager_id": [1, "Administrator"],
    "categ_id": [1, "All products"],
    "seuil_confirm": 0,
    "produce_delay": 1.0,
    "property_account_expense": false,
    "taxes_id": [],
    "external_bookable_notice": 0.0
 */
})();
